import { FQF_TIME_UNITS, formatDurationToMilliseconds, formatDurationToUnit, getDefaultUnit } from 'customer-data-filters-ui/utils/durationUtilities';
import I18n from 'I18n';
import { useState } from 'react';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { InputGroup } from 'foundations-components/transitional/components/InputGroup';
import { NumberInput } from 'foundations-components/transitional/components/NumberInput';
import UISelect from 'UIComponents/input/UISelect';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterOperatorDurationInput = props => {
  const {
    'data-selenium-test': dataSeleniumTest,
    disabled,
    error,
    inputUse,
    onBlur,
    onChange,
    readOnly,
    value: initialDuration
  } = props;
  const isError = error.get('error');
  const errorMessage = error.get('message');
  const initialUnit = getDefaultUnit(initialDuration);
  const [durationInput, updateDurationInput] = useState(formatDurationToUnit(initialDuration, initialUnit));
  const [currentUnit, updateCurrentUnit] = useState(initialUnit);
  const langKey = 'customerDataFiltersUI.customerDataFilters.FilterOperatorDurationInput.DurationUnits';
  const DurationUnitOptions = [{
    text: I18n.text(`${langKey}.seconds`, {
      count: durationInput || 0
    }),
    value: FQF_TIME_UNITS.seconds
  }, {
    text: I18n.text(`${langKey}.minutes`, {
      count: durationInput || 0
    }),
    value: FQF_TIME_UNITS.minutes
  }, {
    text: I18n.text(`${langKey}.hours`, {
      count: durationInput || 0
    }),
    value: FQF_TIME_UNITS.hours
  }, {
    text: I18n.text(`${langKey}.days`, {
      count: durationInput || 0
    }),
    value: FQF_TIME_UNITS.days
  }];
  const handleValueChange = event => {
    const {
      target: {
        value
      }
    } = event;
    if (typeof value !== 'number') {
      onChange(syntheticEvent(null));
      return;
    }
    const valueInMilliseconds = Math.floor(formatDurationToMilliseconds(value, currentUnit));
    updateDurationInput(value);
    onChange(syntheticEvent(valueInMilliseconds));
  };
  const handleUnitChange = event => {
    const {
      target: {
        value
      }
    } = event;
    updateCurrentUnit(value);
    if (typeof durationInput !== 'number') {
      onChange(syntheticEvent(null));
      return;
    }
    const valueInMilliseconds = Math.floor(formatDurationToMilliseconds(durationInput, value));
    onChange(syntheticEvent(valueInMilliseconds));
  };
  return /*#__PURE__*/_jsxs(InputGroup, {
    use: "itemRight",
    children: [/*#__PURE__*/_jsx(FormControl, {
      "aria-label": I18n.text('newCustomerDataFilters.fieldSelectFlow.fieldSearchInputAreaLabel'),
      error: isError,
      validationMessage: isError ? errorMessage : null,
      children: /*#__PURE__*/_jsx(NumberInput, {
        "data-selenium-info": "duration",
        "data-selenium-test": dataSeleniumTest,
        disabled: disabled,
        formatter: value => value != null ? I18n.formatNumber(value, {
          precision: 3
        }) : '',
        onBlur: onBlur,
        onChange: handleValueChange,
        readOnly: readOnly,
        value: durationInput
      })
    }), /*#__PURE__*/_jsx(FormControl, {
      "aria-label": I18n.text('newCustomerDataFilters.fieldSelectFlow.fieldSearchInputAreaLabel'),
      children: /*#__PURE__*/_jsx(UISelect, {
        buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined,
        clearable: false,
        "data-selenium-info": "unit",
        "data-selenium-test": dataSeleniumTest,
        disabled: disabled,
        onChange: handleUnitChange,
        options: DurationUnitOptions,
        readOnly: readOnly,
        value: currentUnit
      })
    })]
  });
};
export default FilterOperatorDurationInput;